{
  "remove": "Odstrániť"
}
